import { PayloadAction, configureStore, createSlice } from "@reduxjs/toolkit";

const crfSlice = createSlice({
  name: "crfSlice",
  initialState: {
    crfCalculationId: "",
    tdCalculationId: "",
  },
  reducers: {
    setCrfCalculationId: (state, action: PayloadAction<string>) => {
      state.crfCalculationId = action.payload;
    },
    setTdCalculationId: (state, action: PayloadAction<string>) => {
      state.tdCalculationId = action.payload;
    },
    setCalculationIds: (state, action: PayloadAction<{ crfCalculationId: string; tdCalculationId: string }>) => {
      state.crfCalculationId = action.payload.crfCalculationId;
      state.tdCalculationId = action.payload.tdCalculationId;
    },
  },
});

export const { reducer: CrfReducer } = crfSlice;
export const { setCrfCalculationId, setTdCalculationId, setCalculationIds } = crfSlice.actions;
